import { Injectable } from '@angular/core';
import { DirectoryService as CommonDirectoryService } from '@iot-platform/data-access';
import { EnergyModes, ModbusTable, ModemRadioBands } from '@iot-platform/models/dalia';
import { catchError, Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DirectoryService extends CommonDirectoryService {
  getModbusTable(): Observable<ModbusTable> {
    return this.http.get<ModbusTable>(`${this.environment.api.url_connector}${this.environment.api.endpoints.modbusTable}`).pipe(
      catchError(() =>
        of({
          lists: {},
          mappings: {}
        })
      )
    );
  }

  getModemRadioBands(): Observable<ModemRadioBands> {
    return this.http.get<ModemRadioBands>(`${this.environment.api.url_connector}${this.environment.api.endpoints.modemRadioBands}`).pipe(catchError(() => of(null)));
  }

  getEnergyModes(): Observable<EnergyModes> {
    return this.http.get<EnergyModes>(`${this.environment.api.url_connector}${this.environment.api.endpoints.energyModes}`).pipe(catchError(() => of(null)));
  }
}
